import { get, post } from '@/utils/http-helper';

const GET_COURSES = '/course/get';
const START_COURSE = '/course/course-started';
const ABANDON_COURSE = '/course/course-abandoned';
const FINISH_COURSE = '/course/course-finished';
const EXIT_COURSE = '/course/course-exit';

export default {
  state: {
    courses: null,
    courseProgressId: null,
    isCourseFinished: false,
  },
  actions: {
    async getCourses({ commit }, data) {
      const courses = await get(GET_COURSES, { ...data });

      if (courses.status) {
        commit('updateCourses', courses.data);
      }
    },

    async startCourse({ commit }, data) {
      const response = await post(START_COURSE, { ...data });

      if (response.status) {
        commit('updateCourseProgressId', response.data.course_progress_id);
        commit('updateIsCourseFinished', false);
      }

      return response;
    },

    async abandonCourse({ state, commit }, data) {
      if (!state.courseProgressId) {
        return;
      }

      if (state.isCourseFinished) {
        await post(EXIT_COURSE, { ...data, course_progress_id: state.courseProgressId });
        commit('updateIsCourseFinished', false);
      } else {
        await post(ABANDON_COURSE, { ...data, course_progress_id: state.courseProgressId });
      }

      commit('updateCourseProgressId', null);
    },

    async finishCourse({ state, commit }, data) {
      if (state.isCourseFinished) {
        return;
      }
      
      const response = await post(FINISH_COURSE, { ...data, course_progress_id: state.courseProgressId });

      if (response.status) {
        commit('updateIsCourseFinished', true);
      }

      return response;
    },
  },
  mutations: {
    updateCourses(state, courses) {
      state.courses = courses;
    },
    updateCourseProgressId(state, id) {
      state.courseProgressId = id;
    },
    updateIsCourseFinished(state, isFinished) {
      state.isCourseFinished = isFinished;
    },
  },
  getters: {
    getCourses: state => state.courses,
  },
};
